import React from 'react'

export const ChangeButtonSecond = ({size, text, stateSecond, setStateSecond, setStatePrincipal}) => {
  return (
    <button className={`w-[${size}]  h-8 rounded
    ${stateSecond==='active' ? "bg-[#ccc]": "bg-[#5e5e5e] text-white"}`} onClick={()=> {setStateSecond('active'); setStatePrincipal('')}}>{text}</button>
  )
}